// Context library (agent context tab) styles (WEB-8003). Context feature
// styles (WEB-7961 folder). Composed by workspaceStyles.ts in place.
export const contextLibrary = `
/* ===== Context library (agent context tab) ===== */
.ws-ctx-dropzone {
  border: 1.5px dashed var(--ws-line-2);
  border-radius: var(--ws-r-lg);
  padding: 28px;
  text-align: center;
  background: var(--ws-soft);
  color: var(--ws-ink-3);
  transition: all 0.18s;
  cursor: pointer;
  margin-bottom: 16px;
}
.ws-ctx-dropzone:hover, .ws-ctx-dropzone.over {
  border-color: var(--ws-ink-3);
  background: var(--ws-hover);
  color: var(--ws-ink-2);
}
.ws-ctx-dz-icon {
  width: 40px; height: 40px; margin: 0 auto 10px;
  border-radius: 10px; background: white;
  border: 1px solid var(--ws-line);
  display: grid; place-items: center;
  color: var(--ws-ink-3);
}
.ws-ctx-dz-title {
  font-family: var(--ws-serif);
  font-size: 17px; color: var(--ws-ink);
  margin-bottom: 4px; font-weight: 600;
}
.ws-ctx-dz-sub { font-size: 12.5px; color: var(--ws-ink-4); }
.ws-ctx-dz-types {
  display: flex; gap: 5px; justify-content: center; margin-top: 12px; flex-wrap: wrap;
}
.ws-ctx-dz-btn {
  display: inline-flex; align-items: center; gap: 5px;
  border: 1px solid var(--ws-line);
  background: var(--ws-panel);
  color: var(--ws-ink-2);
  cursor: pointer;
  font-family: var(--ws-sans);
}
.ws-ctx-dz-btn:hover { background: var(--ws-hover); }

.ws-ctx-composer {
  display: flex; flex-direction: column; gap: 8px;
  background: var(--ws-soft);
  border: 1px solid var(--ws-line);
  border-radius: var(--ws-r-md);
  padding: 14px;
  margin-bottom: 16px;
}
.ws-ctx-composer-actions {
  display: flex; justify-content: flex-end; gap: 6px;
}
.ws-ctx-composer-hint {
  font-size: 11.5px; color: var(--ws-ink-4); line-height: 1.4;
}

.ws-ctx-meter {
  display: flex; align-items: center; gap: 12px;
  padding: 10px 14px;
  background: var(--ws-soft);
  border: 1px solid var(--ws-line);
  border-radius: var(--ws-r-md);
  margin: 0 0 14px;
}
.ws-ctx-meter-label {
  font-size: 11px; font-weight: 600; letter-spacing: 0.08em;
  text-transform: uppercase; color: var(--ws-ink-4);
}
.ws-ctx-meter-bar {
  flex: 1; height: 6px;
  background: white; border-radius: 999px; overflow: hidden;
  border: 1px solid var(--ws-line);
}
.ws-ctx-meter-fill { height: 100%; background: var(--ws-ink); border-radius: 999px; }
.ws-ctx-meter-text {
  font-size: 12px; color: var(--ws-ink-3);
  font-variant-numeric: tabular-nums; white-space: nowrap;
}

.ws-ctx-list { display: flex; flex-direction: column; gap: 6px; }
.ws-ctx-item {
  display: grid;
  grid-template-columns: 36px 1fr auto auto auto;
  gap: 12px;
  align-items: center;
  padding: 10px 14px;
  background: var(--ws-panel);
  border: 1px solid var(--ws-line);
  border-radius: var(--ws-r-md);
}
.ws-ctx-item:hover { background: var(--ws-soft); }
.ws-ctx-item--editing {
  grid-template-columns: 36px 1fr;
  align-items: flex-start;
}
.ws-ctx-edit-form {
  display: flex;
  flex-direction: column;
  gap: 8px;
  flex: 1;
}
.ws-ctx-thumb {
  width: 36px; height: 36px; border-radius: 7px;
  display: grid; place-items: center;
  font-family: var(--ws-mono); font-size: 10px; font-weight: 700;
  letter-spacing: 0.04em;
  color: white;
}
.ws-ctx-thumb.pdf { background: var(--ws-err); }
.ws-ctx-thumb.xlsx { background: var(--ws-ok); }
.ws-ctx-thumb.image { background: var(--ws-a-postmeeting); }
.ws-ctx-thumb.link { background: var(--ws-info); }
.ws-ctx-thumb.text { background: var(--ws-ink-3); }
.ws-ctx-thumb.note { background: var(--ws-ink); }
.ws-ctx-name { font-size: 13.5px; font-weight: 500; color: var(--ws-ink); }
.ws-ctx-meta { font-size: 11.5px; color: var(--ws-ink-4); margin-top: 1px; }

.ws-ctx-actions { display: inline-flex; gap: 4px; }
.ws-btn-icon {
  width: 26px; height: 26px;
  border-radius: 6px;
  border: 1px solid transparent;
  background: transparent;
  color: var(--ws-ink-3);
  cursor: pointer;
  display: inline-grid; place-items: center;
}
.ws-btn-icon:hover {
  background: var(--ws-hover);
  border-color: var(--ws-line);
  color: var(--ws-ink);
}

.ws-pill.ws-pill-err {
  background: rgba(184, 74, 62, 0.08);
  color: var(--ws-err);
  border: 1px solid rgba(184, 74, 62, 0.25);
  cursor: pointer;
}

.ws-ctx-privacy {
  margin-top: 14px;
  padding: 12px;
  background: var(--ws-soft);
  border: 1px solid var(--ws-line);
  border-radius: var(--ws-r-md);
  font-size: 12.5px; color: var(--ws-ink-3);
  display: flex; gap: 10px; align-items: flex-start;
}
.ws-ctx-privacy strong { color: var(--ws-ink-2); }
`;
